export default __webpack_public_path__ + "static/media/section_2_computers@4x.d91e9f64.png";